
module.exports = function getResource(label) {
    const resources = {
        color: 'Couleur',
        size: 'Format',
        edit: 'Modifier'

    };

    return resources[label];
};
